import React from 'react'
import '../../styles/Footer.less'

export default function Footer() {
    return (
        <div className="row footer">
            <div className="col-xs-12 footer">
                <a rel="noopener noreferrer" href="/">Stakehouse Sports</a> | <a rel="noopener noreferrer" href="/privacy">Privacy Policy</a>
            </div> 
        </div>
    )
}
